<template>
  <div class="button-container">
    <button
      @click="selectButton('list')"
      :class="{ selected: isSelected('list') }"
    >
      <i class="bi bi-list-ul"></i>
    </button>
    <button
      @click="selectButton('calendar')"
      :class="{ selected: isSelected('calendar') }"
    >
      <i class="bi bi-calendar4"></i>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    activeButton: {
      type: String,
      default: "list",
    },
  },
  methods: {
    selectButton(button) {
      // 当点击按钮时，发出相应的事件
      this.$emit(button === "list" ? "listClick" : "calendarClick");
    },
    isSelected(button) {
      // 检查是否该按钮应该被激活
      return this.activeButton === button;
    },
  },
};
</script>

<style scoped>
.button-container button {
  border: none;
  cursor: pointer;
  margin: 2px;
  padding: 5px 10px;
  font-size: 0.9rem;

  border-radius: 3px;
  background-color: transparent;
  color: rgb(214, 214, 214);
}

.button-container button.selected {
  background-color: rgb(190, 190, 190);
  color: rgb(255, 255, 255);
}
</style>
